export default {"src":"/_next/static/image/public/images/ic_ios.f16f0c42f36bef90863369d2776cb33e.svg","height":37,"width":108};